module.exports = __webpack_public_path__ + "static/media/johnBalfour.5a53436d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/johnBalfour.jpg
// module id = 1575
// module chunks = 1